// Shared display-formatting helpers used by both App.jsx (mobile) and
// DesktopApp.jsx (desktop) shells.

export const short = (s) =>
  s?.startsWith("0x") && s.length > 12 ? `${s.slice(0, 6)}…${s.slice(-4)}` : s;

// Prefer Polymarket's own leaderboard username over a shortened address —
// same name a user would see on polymarket.com itself, which is the point.
export const displayName = (username, address) => username || short(address);

// Prefer the per-market slug via /market/{slug} — confirmed live 2026-08-02
// that this 307-redirects to /event/{eventSlug}/{slug}, the exact sub-market
// page (not the whole multi-market event overview). This matters most for
// events with several markets under one event (e.g. Fed rate-decision
// events with 4 separate Yes/No markets) — /market/{slug} lands the user on
// the precise market that was traded instead of a page listing all of them.
// eventSlug is only a fallback for the rare case `slug` is missing —
// polymarket.com/event/{x} only resolves for the EVENT-level slug, the
// per-market slug 404s there (confirmed live against two unrelated markets).
export const marketUrl = (slug, eventSlug) => {
  if (slug) return `https://polymarket.com/market/${slug}`;
  if (eventSlug) return `https://polymarket.com/event/${eventSlug}`;
  return null;
};

export const fmtUsd = (n, signed) => {
  if (n == null) return "—";
  const sign = n < 0 ? "-" : signed ? "+" : "";
  const a = Math.abs(n);
  return a >= 1e6 ? `${sign}$${(a / 1e6).toFixed(2)}m`
       : a >= 1e3 ? `${sign}$${(a / 1e3).toFixed(1)}k`
       : `${sign}$${a.toFixed(0)}`;
};

export const timeAgo = (ts) => {
  if (!ts) return "";
  const then = typeof ts === "number" ? ts : Date.parse(ts);
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (s < 45)    return "just now";
  if (s < 3600)  return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
